<!-- 销售经理查看客户详情的页面,复制于置业顾问查看客户详情的页面,做了部分修改,分开管理 -->
<template>
  <div class="progress-detail">
    <div class="header">
      <div class="top"></div>
      <main class="main">
        <!-- 用户信息框框组件 -->
        <!-- 我也不想这么写,但改起来太麻烦 -->
        <customer-info
          :surname="surname"
          :user_name="user_name"
          :recommend_id="recommend_id"
          :contact_number="contact_number"
          :gender="gender"
          :remark="remark"
          :tagList="tagList"
        />
      </main>
    </div>
    <div class="content">
      <!-- 推荐人信息组件 -->
      <recommend-info
        :rec_username="rec_username"
        :rec_user_phone="rec_user_phone"
        :rec_date="rec_date"
        :subscribe_date="subscribe_date"
        :sign_date="sign_date"
      />
      <!-- 跟进记录模块 -->
      <div class="CENTER content_title">
        <van-sidebar v-model="activeKey">
          <van-sidebar-item title="跟进记录" />
        </van-sidebar>
      </div>
      <!-- 跟进记录 -->
      <div class="recordCall" v-if="recordList.length !== 0">
        <van-record-card :recordList="recordList" :lastIndex="0" />
      </div>
      <!-- 暂无数据 -->
      <div class="no-data" v-else>
        <no-data
          tip="抓紧时间联系客户"
          :defineStyle="'justify-content: normal;margin-top: 50px;'"
        />
      </div>
    </div>
    <!-- loading -->
    <loading :show="loadingStatus"></loading>
  </div>
</template>

<script>
import loading from "@/components/loading";

import nodata from "@/components/nodata";
import { mapMutations } from "vuex";
import CustomerInfo from "@/components/CustomerDetail/CustomerInfo";
import RecommendInfo from "@/components/CustomerDetail/RecommendInfo";
import vanRecordCard from "@/components/vanRecordCard";
import { Sidebar, SidebarItem, Toast } from "vant";

export default {
  components: {
    "no-data": nodata,
    "van-sidebar": Sidebar,
    "van-sidebar-item": SidebarItem,
    "van-record-card": vanRecordCard,
    CustomerInfo,
    RecommendInfo,
    loading,
  },
  data() {
    return {
      loadingStatus: false,
      from: null,
      surname: "",
      user_name: "",
      recommend_id: "", // 推荐记录id
      contact_number: "", // 被推荐人电话
      rec_username: "", // 推荐人姓名
      rec_user_phone: "", // 推荐人电话
      rec_date: "", // 推荐日期
      subscribe_date: "", //认购时间
      sign_date: "", //签约时间
      change_user_name: "",
      gender: "0",
      recordList: [], // 电话记录
      iseditor: true, // true 点击开始修改
      showBeiZhuModel: false,
      activeKey: 0,
      remark: "",
      nan_select_icon: require("../../common/images/recommend/sex_nan_select.png"),
      nv_select_icon: require("../../common/images/recommend/sex_nv_select.png"),
      flag: true, //防抖标识
      timer: null, // 定时器标识
      smsCheckSuccess: false, //验证短信是否成功
      tagList: [], //标签
      allname: "",
      showMore: false,
      handleClick: false, //禁止点击
    };
  },
  created() {
    // this.loadingStatus = true;
    document.title = "老带新推荐";
    // this.$jsBridge.callHandler("toggleTitleBar", '{"showTitleBar":false}');
    // this.$jsBridge.callHandler("dispatchBackBtn");
    // this.$jsBridge.registerhandler("onBackPressed", () => {
    //   this.$router.push({
    //     name: "progress",
    //   });
    // });
    this.recommend_id =
      JSON.stringify(this.$route.query) !== "{}"
        ? this.$route.query.id
        : this.$store.state.recommend_id;

    this.getData();
  },
  methods: {
    ...mapMutations(["SAVE_RECOMMEND_ID"]),
    showModel() {
      this.showBeiZhuModel = true;
    },
    //返回列表页
    goBack() {
      this.$router.push({
        name: "progress",
      });
    },
    //更多标签
    goTags() {
      this.$router.push({
        name: "tagList",
        params: {
          tagList: this.tagList,
          id: this.recommend_id,
        },
      });
    },
    //头部标签显示
    showNot(v) {
      if (v === "需求业态") {
        return false;
      } else if (v === "需求面积") {
        return false;
      } else if (v === "购房意向") {
        return false;
      } else {
        return true;
      }
    },
    //用户验证
    validation() {
      //发送短信验证码
      this.$api.sendInfo({ recommendId: this.recommend_id }).then(() => {
        Toast.success("验证码发送成功");
      });
      this.$router.push({
        name: "validation",
        query: {
          recommendId: this.recommend_id,
        },
      });
    },
    // 编辑姓名
    editor() {
      this.iseditor = false;
      this.change_user_name = this.user_name;
    },
    changeName() {
      if (this.change_user_name.length > 10) {
        Toast.fail("最多输入10个字，请重新输入");
      } else if (this.change_user_name.length > 0) {
        this.$api
          .changeUserName({
            recommendId: this.recommend_id,
            lastName: this.change_user_name,
          })
          .then((res) => {
            if (res.code === "0000") {
              this.user_name = this.change_user_name;
            }
          });
      }
      this.iseditor = true;
    },
    // 联系客户
    callPhone(mobile) {
      //打电话
      var isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (this.flag) {
        this.flag = false;
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.flag = true;
        }, 2000);

        this.SAVE_RECOMMEND_ID({ recommend_id: this.recommend_id }); // 保存id
        // 首次来电
        if (!this.recordList.length) {
          this.$router.push({
            name: "callMatch",
            params: {
              surname: this.surname,
              user_name: this.user_name,
              gender: this.gender,
              contact_number: this.contact_number, // 被推荐人电话
              rec_username: this.rec_username, // 推荐人姓名
              rec_user_phone: this.rec_user_phone, // 推荐人电话
              id: this.recommend_id, // 推荐人id
              connect_date: this.getTime(), // 去电时间
              mobile: mobile, // 电话号码
              type: this.$route.query.type,
              allname: this.allname,
            },
          });
          // 如果不是IOS，在此处唤起拨号盘
          if (!isiOS) {
            window.location.href = "tel:" + mobile;
          }
        } else {
          // 非首次来电

          let params = {
            recommendId: this.recommend_id,
            connectDate: "",
            remark: "", // 备注
            isComingCall: 0, // 0-去电 1-来电 3-首次去电
            tagList: [
              {
                propertyName: "需求业态", //属性名
                propertyValue: "", //属性值
              },
              {
                propertyName: "需求面积", //属性名
                propertyValue: "", //属性值
              },
              {
                propertyName: "购房意向", //属性名
                propertyValue: "", //属性值
              },
              {
                propertyName: "家庭结构", //属性名
                propertyValue: "", //属性值
              },
              {
                propertyName: "年龄段", //属性名
                propertyValue: "", //属性值
              },
              {
                propertyName: "总价预算", //属性名
                propertyValue: "", //属性值
              },
              {
                propertyName: "付款方式", //属性名
                propertyValue: "", //属性值
              },
              {
                propertyName: "购买目的", //属性名
                propertyValue: "", //属性值
              },
              {
                propertyName: "从事行业", //属性名
                propertyValue: "", //属性值
              },
              {
                propertyName: "客户最关注的方面（多选）", //属性名
                propertyValue: "", //属性值
              },
              {
                propertyName: "备注信息", //属性名
                propertyValue: "", //属性值
              },
            ],
          };

          if (this.tagList.length !== 0) {
            params.tagList = [
              {
                propertyName: "需求业态", //属性名
                propertyValue: this.tagList[0].propertyValue, //属性值
              },
              {
                propertyName: "需求面积", //属性名
                propertyValue: this.tagList[1].propertyValue, //属性值
              },
              {
                propertyName: "购房意向", //属性名
                propertyValue: this.tagList[2].propertyValue, //属性值
              },
              {
                propertyName: "家庭结构", //属性名
                propertyValue: this.tagList[3].propertyValue, //属性值
              },
              {
                propertyName: "年龄段", //属性名
                propertyValue: this.tagList[4].propertyValue, //属性值
              },
              {
                propertyName: "总价预算", //属性名
                propertyValue: this.tagList[5].propertyValue, //属性值
              },
              {
                propertyName: "付款方式", //属性名
                propertyValue: this.tagList[6].propertyValue, //属性值
              },
              {
                propertyName: "购买目的", //属性名
                propertyValue: this.tagList[7].propertyValue, //属性值
              },
              {
                propertyName: "从事行业", //属性名
                propertyValue: this.tagList[8].propertyValue, //属性值
              },
              {
                propertyName: "客户最关注的方面（多选）", //属性名
                propertyValue: this.tagList[9].propertyValue, //属性值
              },
              {
                propertyName: "备注信息", //属性名
                propertyValue: this.tagList[10].propertyValue, //属性值
              },
            ];
          }
          this.$api.saveCallRecords(params).then(() => {
            this.getData(true, mobile);
          });
        }
      }
    },
    // 获取用户详情
    /**
     * @params isCall <Boolean> 是否是拨号触发
     *
     */
    getData(isCall, mobile) {
      this.$api
        .getUserDetail({ recommendId: this.recommend_id })
        .then((res) => {
          let date = res.body.mobileRecDTO;
          this.surname = date.presentee.substr(0, 1);
          this.user_name = date.presentee.substr(1);
          this.allname = date.presentee;
          this.gender = date.gender;
          this.contact_number = date.contactNumber;
          this.remark = date.remark;
          this.rec_username = date.recommendName;
          this.rec_user_phone = date.recommendMobile;
          // 推荐日期
          this.rec_date = date.recommendDateTime || date.createDate;
          // 签约时间
          this.sign_date = date.signDate;
          // 认购时间
          this.subscribe_date = date.subscribeTime;
          this.recordList =
            res.body.connectRecord === null ? [] : res.body.connectRecord;
          this.smsCheckSuccess =
            date.smsCheckSuccess === null ? false : date.smsCheckSuccess;

          this.tagList = res.body.tagList === null ? [] : res.body.tagList;

          this.showMore = this.tagList.every((item) => {
            return item.propertyValue === "";
          });
          this.loadingStatus = false;

          if (isCall) {
            setTimeout(() => {
              window.location.href = "tel:" + mobile;
            }, 500);
          }
        })
        .catch(() => {
          this.loadingStatus = false;
        });
    },
    // 获取当前时间
    getTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      if (month < 10) month = "0" + month;
      let day = date.getDate();
      if (day < 10) day = "0" + day;
      let hour = date.getHours();
      if (hour < 10) hour = "0" + hour;
      let min = date.getMinutes();
      if (min < 10) min = "0" + min;
      let ss = date.getSeconds();
      if (ss < 10) ss = "0" + ss;
      return `${year}-${month}-${day} ${hour}:${min}:${ss}`;
    },
  },
  computed: {
    noDataImg() {
      // 判断参数,给img路径赋值
      let url = "";
      if (true) {
        url = require("@/common/images/recommend/pending.png");
      } else {
        url = require("@/common/images/recommend/refuse.png");
      }
      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  .CENTER {
    display: flex;

    align-items: center;
  }
  .header {
    height: 260px;
    background: #f7f7f7;
    position: relative;
    .top {
      height: 170px;
      background-image: url("../../common/images/progress/bg.png");
      background-size: 100% 100%;
      overflow: hidden;
      .back_header {
        height: 50px;
        margin-top: 20px;
        position: relative;
        .head {
          display: flex;
          justify-content: space-between;
          align-items: center;

          height: 99px;
          padding-right: 20px;
          font-size: 36px;
          width: 100%;

          color: #fff;
          .back_btn {
            width: 100px;
            height: 99px;
            font-weight: 500;
            display: inline-flex;
            align-items: center;
            padding: 10px;
          }
          .title {
            font-weight: 500;

            text-align: center;
            width: 100%;
            padding-right: 100px;
          }
        }
        .validation {
          position: absolute;
          right: 0;
          top: 20px;
          height: 50px;

          width: 200px;
          font-size: 28px;
          font-weight: 500;
          color: #ffffff;
          display: inline-flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
    .main {
      height: 220px;
      width: 100%;
      padding-left: 30px;
      padding-right: 30px;
      box-sizing: border-box;
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      /* 不能高于toast */
      z-index: 2000;
      .card_info {
        height: 270px;
        display: flex;
        flex-direction: column;
        background: #ffffff;
        border-radius: 40px 0px 40px 0px;
        box-shadow: 0px 4px 20px 0px rgba(96, 139, 122, 0.3);
        .wrap {
          overflow: hidden;
          height: 110px;
          .user_wrap {
            color: #333333;
            height: 40px;
            padding: {
              left: 40px;
              right: 40px;
            }
            font-size: 36px;
            margin-top: 30px;
            justify-content: space-between;
            .show_name {
              flex: 1;
              height: 100%;
            }
            .gender {
              width: 32px;
              height: 36px;
              margin: {
                top: -10px;
                // left: 40px;
                right: 80px;
              }
              img {
                width: 100%;
                height: 100%;
              }
            }
            .name {
              min-width: 100px;
              max-width: 200px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              height: 40px;
            }
            .editor_name {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
            }
            .editor {
              height: 30px;
              width: 30px;
              margin-left: 20px;
              background-image: url("../../common/images/progress/editor.png");
              background-size: 100% 100%;
            }
            .mobile {
              height: 100%;
              width: 220px;
            }
          }
        }
        .tags {
          height: 70px;
          font-size: 24px;
          padding-left: 40px;
          padding-right: 30px;
          box-sizing: border-box;
          .left {
            flex: 1;
          }
          .right {
            width: 80px;
            line-height: normal;
            justify-content: space-around;
            .icon_more {
              width: 10px;
              height: 16px;
              background: url("../../common/images/progress/more.png");
              background-size: 100% 100%;
            }
          }
        }
        .beizu {
          // flex: 1;
          padding-left: 40px;
          padding-right: 30px;
          padding-top: 20px;
          box-sizing: border-box;
          color: #666666;
          font-size: 24px;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
        .van_pop {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 30px 44px;
          color: #fff;
          line-height: 40px;
          letter-spacing: 2px;
          box-sizing: border-box;
          background: transparent;
        }
      }
    }
  }
  .content {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    padding: {
      top: 40px;
      left: 30px;
      right: 30px;
    }
    box-sizing: border-box;

    .info {
      flex: 1;
      display: flex;
      .tuijianPer {
        flex: 1;
        color: #666666;
        .tuijian_avatar {
          width: 38px;
          height: 38px;
          margin-right: 36px;
          background-image: url("../../common/images/progress/tuijian_person.png");
          background-size: 100% 100%;
        }
      }
      .tuijianPer_info {
        color: #333333;
        flex: 2;
        div {
          width: 50%;
          text-align: center;
        }
      }
    }
    .content_title {
      height: 80px;
      justify-content: space-between;
      margin-top: 54px;
      .van-sidebar {
        width: auto !important;
      }
      .add {
        width: 136px;
        height: 52px;
        font-size: 28px;
        display: inline-flex;
        justify-content: center;
        align-items: center;

        color: #fff;
        background: rgba(13, 152, 105, 1);
        border-radius: 36px;
      }
    }
    .recordCall {
      flex: 1;
      width: 100%;
      overflow: scroll;
    }
    .no-data {
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding: {
        left: 30px;
        right: 30px;
      }
      box-sizing: border-box;
      position: relative;
    }
  }
  .button {
    margin: auto;
    justify-content: center;
    width: 690px;
    height: 88px;
    border: none;
    margin-bottom: 90px;
    margin-top: 20px;
    background: rgba(13, 152, 105, 1);
    border-radius: 44px;
    bottom: 80px;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    .icon_mobile {
      width: 36px;
      height: 40px;
      margin-right: 20px;
      background-image: url("../../common/images/progress/mobile.png");
      background-size: 100% 100%;
    }
  }
}
</style>
<style lang="scss">
.progress-detail {
  .van-sidebar-item--select::before {
    width: 6px;
    height: 32px;
    background: rgba(13, 152, 105, 1);
    border-radius: 3px;
  }
  .van-sidebar-item__text {
    width: 196px;
    height: 32px;
    font-size: 36px;
    margin-left: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
  .van-sidebar-item {
    padding: 12px;
  }
  .editor_name {
    font-size: 36px;
    .van-cell {
      font-size: 36px;
      padding: 0;
      flex: 1;
      border-bottom: 0.5px solid #333;
    }
  }
  .tips {
    display: inline-flex;

    width: 60%;
    span {
      font-size: 24px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
      height: 56px;
      &:nth-child(1) {
        margin-left: 0;
      }
    }
    .formats {
      width: 100px;

      background: #d8eee7;
      border-radius: 0px 12px 12px 12px;

      color: #007458;
    }
    .age {
      width: 140px;

      background: #f6eed9;
      border-radius: 0px 12px 12px 12px;
      color: #d79414;
    }
    .type {
      width: 60px;

      background: #dde9f5;
      border-radius: 0px 12px 12px 12px;

      color: #5386b8;
    }
  }
  .loading {
    width: 100%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
